/** Same flag svc-tour gates the endpoints on. Defaults to off. */
export function isFlashAccommodationEnabled(): boolean {
  return window.configs?.ENABLE_FLASH_ACCOMMODATION === 'true';
}

export const FLASH_ACCOMMODATION_TAB_TYPE = 'flash-accommodation';

export const FLASH_ACCOMMODATION_TAB_TITLE = 'Flash accommodation';
